import { IFileMeta } from '../../../data-models/field3.data-model';
import { FileDropField } from './FileDropField';
import { IBaseFieldProps } from './types';

/**
 * Form-field adapter over the presentational {@link FileDropField}. Maps the
 * form renderer meta + `formProps` onto the generic dropzone; the shared UI
 * lives in `FileDropField` (also used by the Document Hub upload zone).
 */
export const FieldFile2 = (props: IBaseFieldProps<IFileMeta>) => {
  const { formField, formProps } = props;
  const { acceptTypes, multiple, maxFileSizeMb, acceptExtensions } = formField.rendererMeta ?? {};
  const defaultValue = multiple ? [] : null;
  const { value = defaultValue, onChange } = formProps;
  const { disabled = false } = formField ?? {};

  return (
    <FileDropField
      value={value}
      onChange={onChange}
      multiple={multiple}
      disabled={disabled}
      acceptTypes={acceptTypes}
      acceptExtensions={acceptExtensions}
      maxFileSizeMb={maxFileSizeMb}
    />
  );
};
